import { LaunchContext } from "@carnegie-learning/k12-types";
import { Action, createReducer, on } from "@ngrx/store";
import * as fromLaunchContextActions from "../actions/launch-context.action";

export interface LaunchContextState {
    launchContext: LaunchContext | null;
}

export const initialState: LaunchContextState = {
    launchContext: null
};
const launchContextReducer = createReducer(
    initialState,
    on(
        fromLaunchContextActions.setLaunchContext,
        (state, { payload }) => {
            return {
                ...state,
                launchContext: payload
            };
        }
    ),
)
export function reducer(
    state: LaunchContextState | undefined,
    action: Action
) {
    return launchContextReducer(state, action);
}

export const getLaunchContext = (state: LaunchContextState) => state?.launchContext;
